import axios from 'axios'
import _ from 'lodash'
import { stringify } from 'query-string'
import {
  HTTP_METHOD_DELETE,
  HTTP_METHOD_GET,
  HTTP_METHOD_POST,
  URL_ALL_DELETE_DOWNLOAD,
  URL_ALL_DELETE_MYPURCHASE_PACKAGE,
  URL_ALL_DELETE_MYVIEW_CONTENTS,
  URL_ALL_DELETE_PURCHASE_VOUCHER,
  URL_CATEGORY_LIST,
  URL_DELETE_ALARMS,
  URL_DELETE_ALARMS_CONTENTS,
  URL_DELETE_ALARMS_DETAIL,
  URL_DELETE_DOWNLOADS,
  URL_DELETE_MYPURCHASE_CONTENTS,
  URL_DELETE_MYPURCHASE_PRODUCTS,
  URL_DELETE_MYVIEW_CONTENTS,
  URL_DELETE_USER_QNA,
  URL_DELETE_ZZIM_BASEBALL,
  URL_DELETE_ZZIM_CONTENTS,
  URL_GET_ADULT_VERIFICATION_STATUS,
  URL_GET_ALARMS,
  URL_GET_ALARMS_CONTENTS,
  URL_GET_ALARMS_NEW,
  URL_GET_ALARMS_RECEIVER,
  URL_GET_CLIP_CONTENTS,
  URL_GET_CLIP_CONTENTS_CF,
  URL_GET_CLIP_CONTENTS_DETAIL,
  URL_GET_CLIP_SMR_BRAND_INFO,
  URL_GET_CLIP_SMR_CONTENTS,
  URL_GET_CLIP_SMR_POPULAR_CONTENTS,
  URL_GET_CONTENT_RECOMMEND_LIST,
  URL_GET_DOWNLOADS,
  URL_GET_EVENTS,
  URL_GET_EVENTS_CONTENTS_DETAIL_BANNER,
  URL_GET_EVENTS_CONTENTS,
  URL_GET_EVENTS_DETAIL,
  URL_GET_EVENTS_NOTICE,
  URL_GET_EVENTS_NOTICE_DETAIL,
  URL_GET_FAQS,
  URL_GET_FAQS_DETAIL,
  URL_GET_FAQS_RECOMMEND,
  URL_GET_FILTERS,
  URL_GET_GAME_CONDITION_LIST,
  URL_GET_GUID_ISSUE,
  URL_GET_HOMESHOPPING,
  URL_GET_HOMESHOPPING_ADD_INFO,
  URL_GET_IP,
  URL_GET_LIVE_ALL_CHANNELS,
  URL_GET_LIVE_ALL_CHANNELS_CF,
  URL_GET_LIVE_CHANNELS_DETAIL,
  URL_GET_LIVE_EPGS,
  URL_GET_LIVE_EPGS_CHANNELS,
  URL_GET_LIVE_EPGS_CHANNELS_DETAIL,
  URL_GET_LIVE_GENRE_CHANNELS,
  URL_GET_LIVE_POPULAR_CHANNELS,
  URL_GET_MOVIE_CONTENTS,
  URL_GET_MOVIE_CONTENTS_DETAIL,
  URL_GET_MOVIE_RELATED_CONTENTS,
  URL_GET_MULTISECTIONS,
  URL_GET_MY_SUMMARY,
  URL_GET_MYCOIN_LIST_CHARGED,
  URL_GET_MYCOIN_LIST_EXPIRED,
  URL_GET_MYCOIN_SUMMARY,
  URL_GET_MYCOUPONS_LIST,
  URL_GET_MYPURCHASE_CONTENTS_ITEM,
  URL_GET_MYPURCHASE_CONTENTS_PACKAGE,
  URL_GET_MYPURCHASE_PASS_CANCEL,
  URL_GET_MYPURCHASE_PASS_PROMOTION,
  URL_GET_MYPURCHASE_PASS_PROMOTION_CONTINUE,
  URL_GET_MYPURCHASE_PRODUCTS,
  URL_GET_MYVIEW_CONTENTS,
  URL_GET_NOTICES,
  URL_GET_NOTICES_COMPANY_INFO_BOARD,
  URL_GET_NOTICES_COMPANY_INFO_BOARD_DETAIL,
  URL_GET_NOTICES_DETAIL,
  URL_GET_POOQZONE_ADULT,
  URL_GET_POOQZONE_CHECK,
  URL_GET_PURCHASE_PRODUCT_CONTENTS,
  URL_GET_PURCHASE_PRODUCTS,
  URL_GET_PURCHASE_PRODUCTS_UPSELL,
  URL_GET_RECOMMENDATION_MOVIE,
  URL_GET_RECOMMENDATION_VOD,
  URL_GET_SEARCH,
  URL_GET_SEARCH_FAQ,
  URL_GET_SEARCH_INSTANCE_KEYWORDS,
  URL_GET_SEARCH_LIST,
  URL_GET_SEARCH_MULTI_SECTION,
  URL_GET_SEARCH_NOTICE,
  URL_GET_SEARCH_POPULAR_KEYWORDS,
  URL_GET_SEARCH_RECOMMEND_KEYWORDS,
  URL_GET_SEARCH_RECOMMEND_LIST,
  URL_GET_SERVICE_LOCATION,
  URL_GET_STADIUM_CONDITION_LIST,
  URL_GET_STREAMING,
  URL_GET_TAGS_GROUPS,
  URL_GET_TERMS,
  URL_GET_TEXT_RELAY,
  URL_GET_TEXT_RELAY_CONVERT,
  URL_GET_THEMES,
  URL_GET_THEMES_CONTENTS,
  URL_GET_THEMES_DETAIL,
  URL_GET_THEMES_LIST,
  URL_GET_THEMES_RELATED,
  URL_GET_TID,
  URL_GET_UISERVICE_BANNER_MULTI,
  URL_GET_UISERVICE_BANNER_SINGLE,
  URL_GET_USER,
  URL_GET_USER_QNA,
  URL_GET_USER_QNA_DETAIL,
  URL_GET_VOD_ALLPROGRAMS,
  URL_GET_VOD_CONTENTS_DETAIL,
  URL_GET_VOD_NEW_CONTENTS,
  URL_GET_VOD_POPULAR_CONTENTS,
  URL_GET_VOD_POPULARPROGRAMS,
  URL_GET_VOD_PROGRAMS_CONTENTID,
  URL_GET_VOD_PROGRAMS_CONTENTS,
  URL_GET_VOD_PROGRAMS_POPULAR_CONTENTS,
  URL_GET_ZZIM_CONTENTS,
  URL_GET_ZZIM_DETAIL,
  URL_OLAP_LOG,
  URL_POST_ADULT_CONFIRM,
  URL_POST_ADULT_OTT,
  URL_POST_ALARMS,
  URL_POST_ALARMS_CONTENTS,
  URL_POST_ALARMS_RECEIVER,
  URL_POST_DOWNLOADS,
  URL_POST_LOGIN,
  URL_POST_LOGOUT,
  URL_POST_MYCOUPONS_ACTIVATE,
  URL_POST_MYCOUPONS_REGISTER,
  URL_POST_MYPURCHASE_PASS_CANCEL,
  URL_POST_MYPURCHASE_PASS_EVENT,
  URL_POST_POOQZONE_LOGIN,
  URL_POST_TAG_SEARCH_CF,
  URL_POST_USER_PURCHASE_CANCEL,
  URL_POST_ZZIM_BASEBALL,
  URL_POST_ZZIM_DETAIL,
  URL_TAGS_LIST,
  URL_GET_HIGHLIGHT_CONTENTS,
  URL_GET_HIGHLIGHT_PLAYER_LIST,
  URL_GET_GAME_RECORD_LIST,
  URL_GET_MONTHLY_GAME_RESULT,
  URL_GET_TEAM_LATELY_GAME_DATE,
  URL_KBO_DAILY_SCHEDULE,
  URL_GET_PERMISSION_FOR_CONTENT,
  URL_GET_PROGRAM_NOTICE,
  URL_GET_LIVE_RECOMMEND_CHANNELS_CF,
  URL_GET_PROFILES_ELYSIUM,
  URL_POST_USER_PROFILE_DETAIL_ELYSIUM,
  URL_GET_PROFILE_IMAGE_LIST_ELYSIUM,
  URL_GET_KNOCK,
  URL_PUT_PROMOTION_USER,
  URL_GET_SALTED_HASH,
  URL_POST_TAG_SEARCH_CF_NEW,
  URL_GET_SEARCH_RECOMMEND_CONTENTS,
  URL_GET_SEARCH_POPULAR_CONTENTS,
  URL_GET_VOUCHER,
  URL_GET_VOD_LANDING_INFO,
  URL_GET_VOD_RELATED_CONTENTS,
  URL_GET_MOVIE_SERIES_CONTENTS,
  URL_GET_VOD_EPISODE_LIST, API_BASE_URL_FROZEN
} from '@/common/utils/request.const'
import {
  getDomainWithPrefix,
  getTimeStamp, getUnixTimeStamp, removePrefixEmptyString, setServiceLocationInfo, getDomainWithWordPrefix
} from '@/common/utils/common'
import { EMERGENCY_JSON_URL } from '@/common/resources/const'
import constant from '@/common/resources/constant'
import { emptyBandResult, emptyListResult, emptySearchFaqList } from '@/common/resources/empty-resposne'
import { apiRequest, applyPath, applyQueryString, getCommonParam } from '@/common/utils/request.common'

// ****************************************
// Real API
// ****************************************
/**
 * 알람 목록을 조회한다.
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 */
export const getAlarms = ({ offset = 0, limit = 10 }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_ALARMS, { offset, limit }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 사용자에게 수신된 전체 알람에 대해 읽음 설정 처리를 한다.
 */
export const postAlarms = () => {
  return apiRequest({
    url: URL_POST_ALARMS,
    method: HTTP_METHOD_POST
  })
}
/**
 * 사용자에게 수신된 알람에 대해 상태별(전체,읽음,안읽음) 삭제 처리를 한다.
 * @param status 삭제할 알람 상태 [all, read(읽음 상태만), unread(읽지 않은 상태만)]
 */
export const deleteAlarms = ({ status }) => {
  return apiRequest({
    url: URL_DELETE_ALARMS,
    method: HTTP_METHOD_DELETE,
    data: {
      status
    }
  })
}
/**
 * 사용자의 LIVE / BROADCAST 알림 목록
 * @param contenttype 콘텐츠 구분 [program, live]
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 */
export const getAlarmsContent = ({ contenttype, offset = 0, limit = 10 }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_ALARMS_CONTENTS, { contenttype, offset, limit }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 사용자의 알람을 설정한다.
 * @param alarmtype [live(시청예약), upload(업로드), movie(영화알림)]
 * @param contentid 시청예약 알람 시 channelid 입력, 업로드 알람 시 programid 입력, 영화 알람 시 movieid 입력
 * @param releasedatetime 예약시간. 시청예약 알람 등록 시에만 입력 예) 2017-09-01 10:00
 */
export const postAlarmsContent = ({ alarmtype, contentid, releasedatetime, programid }) => {
  return apiRequest({
    url: URL_POST_ALARMS_CONTENTS,
    method: HTTP_METHOD_POST,
    data: {
      alarmtype,
      contentid,
      releasedatetime,
      programid
    }
  })
}
/**
 * 사용자가 등록한 특정 알람에 대한 예약을 해제한다.
 * @param alarmtype 알람 등록/해제
 * @param contentid 예약/예약 취소할 콘텐츠 ID 시청예약(channelid), 업로드(programid), 영화(movieid)
 * @param releasedatetime 예약시간. 시청예약 알람(live) 등록 시에만 입력 예) 2017-09-01 10:00
 */
export const deleteAlarmsContent = ({ alarmtype, contentid, releasedatetime }) => {
  return apiRequest({
    url: URL_DELETE_ALARMS_CONTENTS,
    method: HTTP_METHOD_DELETE,
    data: {
      alarmtype,
      contentid,
      releasedatetime
    }
  })
}
/**
 * 특정 콘텐츠의 알람 등록 여부
 * @param alarmtype 콘텐츠 타입 [라이브(시청예약) = live, 프로그램(업로드) = upload, 영화(영화이벤트) = movie]
 * @param contentid 조회할 콘텐츠ID [라이브(시청예약) = channelid, 프로그램(업로드) = programid, 영화(영화이벤트) = movieid]
 */
export const getAlarmContentDetail = ({ alarmtype, contentid }) => {
  return apiRequest({
    url: applyQueryString(applyPath(URL_GET_ALARMS_CONTENTS, contentid), { alarmtype }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 특정 유저의 읽지 않은 알람 개수를 조회한다.
 */
export const getAlarmsNew = () => {
  return apiRequest({
    url: URL_GET_ALARMS_NEW,
    method: HTTP_METHOD_GET
  })
}
/**
 * 사용자의 알람 수신 정보를 조회한다.
 */
export const getAlarmsReceiver = () => {
  return apiRequest({
    url: URL_GET_ALARMS_RECEIVER,
    method: HTTP_METHOD_GET
  })
}

/**
 * 사용자의 알람 종류별 수신여부 정보를 설정한다. (수신 = y, 미수신 = n, 이 설정을 변경하지 않음 = d)
 * @param live 시청예약 알람 설정
 * @param upload 업로드 알람 설정
 * @param movie 영화이벤트 알람 설정
 * @param coupon 쿠폰 알람 설정
 * @param coin 코인 알람 설정
 * @param event 이벤트 당첨 알람 설정
 * @param myview 내가 본 프로그램 업데이트 알람 설정
 * @param popular 인기 콘텐츠 소식 알람 설정
 */
export const postAlarmsReceiver = ({ live, upload, movie, coupon, coin, event, myview, popular }) => {
  return apiRequest({
    url: URL_POST_ALARMS_RECEIVER,
    method: HTTP_METHOD_POST,
    data: { live, upload, movie, coupon, coin, event, myview, popular }
  })
}
/**
 * 사용자에게 수신된 알람 중 특정 알람을 삭제한다.
 * @param alarmid 알람 고유 ID
 */
export const deleteAlarmsDetail = ({ alarmid }) => {
  return apiRequest({
    url: applyPath(URL_DELETE_ALARMS_DETAIL, alarmid),
    method: HTTP_METHOD_DELETE
  })
}
/**
 * 클립 목록 (채널별/프로그램별/회차별/최신순/과거순)을 조회한다.
 * @param channel 채널ID (/filters API 출력값 참조) [all]
 * @param programid 조회할 프로그램의 programid, 제한하지 않는 경우에는 none을 입력한다.
 * @param contentid 조회할 회차의 contentid, 제한하지 않는 경우에는 none을 입력한다.
 * @param genre 클립 장르 (filters API 사용)
 * @param touchtv 터치TV 필터여부
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 * @param orderby 정렬순서 [new(최신순), old(과거순), popular(인기순)]
 * @param smrtype 클립 타입
 */
export const getClipContents =
  ({ channel, programid = 'none', contentid = 'none', genre, touchtv, offset, limit, orderby, smrtype }) => {
    return apiRequest({
      url: applyQueryString(URL_GET_CLIP_CONTENTS,
        {
          channel,
          programid,
          contentid,
          genre,
          touchtv,
          offset,
          limit,
          orderby,
          smrtype
        }),
      method: HTTP_METHOD_GET
    })
  }
/**
 * 특정 클립의 상세 정보 조회한다.
 * @param clipid 클립 ID
 */
export const getClipContentsDetail = ({ clipid }) => {
  return apiRequest({
    url: applyPath(URL_GET_CLIP_CONTENTS_DETAIL, clipid),
    method: HTTP_METHOD_GET
  })
}
/**
 * SMR 브랜드 정보
 * @param menu 출력 위치
 * @param channelid 채널 id
 * @param subchannelid 브랜드코드 (서브 채널 id)
 */
export const getClipSmrBrandInfo = ({ menu, channelid, subchannelid }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_CLIP_SMR_BRAND_INFO, { menu, channelid, subchannelid }),
    method: HTTP_METHOD_GET
  })
}

/**
 * 방송사별 브랜드별 콘텐츠 목록
 * @param cpid CP ID
 * @param brandcode 브랜드 코드
 */
export const getClipSmrContents = ({ cpid, brandcode }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_CLIP_SMR_CONTENTS, { cpid, brandcode }),
    method: HTTP_METHOD_GET
  })
}

/**
 * 추천 영상 목록
 * @param cpid CP ID
 * @param clipid 클립 ID
 */
export const getClipSmrPopularContents = ({ cpid, clipid }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_CLIP_SMR_POPULAR_CONTENTS, { cpid, clipid }),
    method: HTTP_METHOD_GET
  })
}

/**
 * 클릭 클립 전송 API
 * @param page 페이지 (CP_HOME, BRAND_HOME, CLIP_END)
 * @param layout 추천영역 (L1, L2)
 * @param targetclipid 클릭한 클립 ID
 * @param cpid CP 고유 아이디
 * @param brand 브랜드 코드
 * @param timestamp 노출 API를 호출한 시간
 * @param requesttime 클릭 한 시간
 *
 */
export const getSendClipOlapLog = ({ page, layout, targetclipid, cpid, brand, timestamp, requesttime }) => {
  let version = '1.0'
  let media = 'SMR_MEMBERS'
  let site = 'SMRINPOOQ'
  let device = 'PC'
  let recomedia = 'SMR'
  brand = brand === '0' ? '' : brand
  const params = {
    version,
    media,
    site,
    device,
    recomedia,
    page,
    layout,
    cpid,
    brand,
    timestamp,
    requesttime,
    targetclipid
  }
  return apiRequest({
    url: applyQueryString(URL_OLAP_LOG, params),
    method: HTTP_METHOD_GET
  })
}
export const getFromUrl = ({ url }) => {
  if (!url.startsWith('http')) {
    url = location.protocol + '//' + url
  }
  return apiRequest({
    url: url,
    method: HTTP_METHOD_GET
  })
}
/**
 * 사용자의 BROADCAST / 영화 다운로드 목록
 * @param contenttype 콘텐츠 구분 [vod, movie]
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 * @param orderby 정렬순서 [new(최신순), old(과거순)]
 */
export const getDownloads = ({ contenttype, offset = 0, limit = 10, orderby }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_DOWNLOADS, { contenttype, offset, limit, orderby }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 이벤트 목록을 조회한다.
 * @param status 이벤트 상태 [all, y(이벤트 중), n(이벤트 종료)]
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 */
export const getEvents = ({ status, offset = 0, limit = 10 }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_EVENTS, { status, offset, limit }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 이벤트 공지사항 게시판 글 상세 (특정 이벤트 포함 콘텐츠 목록[복합])
 * @param eventid 이벤트 고유 ID
 * @param contenttype 콘텐츠타입 (all / live / program / vod / movie / clip)
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 개수
 */
export const getEventsContents = ({ eventid, contenttype, offset, limit }) => {
  return apiRequest({
    url: applyQueryString(applyPath(URL_GET_EVENTS_CONTENTS, eventid), { contenttype, offset, limit }),
    method: HTTP_METHOD_GET
  })
}

/**
 * 이벤트 공지사항 게시판 글 목록 (당첨자 공지용)
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 */
export const getEventsNotice = ({ offset = 0, limit = 10 }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_EVENTS_NOTICE, { offset, limit }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 이벤트 공지사항 게시판 글 상세
 * @param eventid 이벤트 고유 ID
 */
export const getEventsNoticeDetail = ({ eventid }) => {
  return apiRequest({
    url: applyPath(URL_GET_EVENTS_NOTICE_DETAIL, eventid),
    method: HTTP_METHOD_GET
  })
}

/**
 * 특정 이벤트 상세 정보를 조회한다.
 * @param eventid 이벤트 고유 ID
 */
export const getEventsDetail = ({ eventid }) => {
  return apiRequest({
    url: applyPath(URL_GET_EVENTS_DETAIL, eventid),
    method: HTTP_METHOD_GET
  })
}

/**
 * 특정 영화 상세 이벤트 배너 정보
 * @param movieid 영화 고유 iD
 */
export const getEventsBannerMovie = ({ movieid }) => {
  return apiRequest({
    url: applyPath(URL_GET_EVENTS_CONTENTS_DETAIL_BANNER, movieid),
    method: HTTP_METHOD_GET
  })
}

/**
 * 특정 VOD 상세 이벤트 배너 정보
 * @param programid vod 콘텐츠 고유 iD
 */
export const getEventsBannerVod = ({ programid }) => {
  return apiRequest({
    url: applyPath(URL_GET_EVENTS_CONTENTS_DETAIL_BANNER, programid),
    method: HTTP_METHOD_GET
  })
}

/**
 * 고객센터 FAQ 목록을 조회
 * @param type [all, 1(설치/작동오류), 2(결제/요금), 3(이용불편사항), 4(회원정보), 5(기타)]
 * @param faqid 검색 또는 기타 화면에서 faq를 누르고 들어왔을 때 선택된 ID, 화면 해당 ID FAQ는 최상단에 표시
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 * @param orderby 정렬순서 [new(최신순), old(과거순)]
 */
export const getFaqs = ({ type, faqid, offset = 0, limit = 10, orderby }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_FAQS, { type, faqid, offset, limit, orderby }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 고객센터 FAQ 내용을 조회
 * @param faqid 읽어올 글 번호
 */
export const getFaqsDetail = ({ faqid }) => {
  return apiRequest({
    url: applyPath(URL_GET_FAQS_DETAIL, faqid),
    method: HTTP_METHOD_GET
  })
}

/**
 * FAQ 자주 묻는 질문 목록 (운영자 지정)
 */
export const getFaqsRecommend = () => {
  return apiRequest({
    url: URL_GET_FAQS_RECOMMEND,
    method: HTTP_METHOD_GET
  })
}
/**
 * 전체 API에서 사용하는 필터용 목록을 조회한다.
 * @param type 카테고리 리스트 타입 [all(전체), livegenre(live 장르), vodgenre(BROADCAST 장르),
 * vodchannel(BROADCAST 채널), moviegenre(영화 장르), faqcategory(FAQ 카테고리), noticecategory(공지사항 카테고리)]
 */
export const getFilters = ({ type }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_FILTERS, { type }),
    method: HTTP_METHOD_GET
  })
}

/**
 * GUID 신규 발급 및 발급된 GUID 의 타임스탬프 값을 반환한다.
 */
export const getGuidIssue = () => {
  return apiRequest({
    url: URL_GET_GUID_ISSUE,
    method: HTTP_METHOD_GET
  })
}

/**
 * 홈쇼핑 채널 재생 시 표시되는 전화걸기 및 구매하기 정보를 조회한다.
 */
export const getHomeShopping = ({ channelid }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_HOMESHOPPING, { channelid }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 홈쇼핑 채널 재생 시 추가 데이터 정보를 조회한다
 */
export const getHomeShoppingAddinfo = ({ channelid }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_HOMESHOPPING_ADD_INFO, { channelid }),
    method: HTTP_METHOD_GET
  })
}

export const getSameTimeChannels = ({ genre, type, free, offset, limit }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_LIVE_ALL_CHANNELS, { genre, type, free, offset, limit }),
    method: HTTP_METHOD_GET
  })
}

/**
 * 접속 기기의 외부 IP를 조회한다.
 */
export const getIp = () => {
  return apiRequest({
    url: URL_GET_IP,
    method: HTTP_METHOD_GET
  })
}

/**
 * 전체채널
 * @param genre 장르구분
 * @param type 종류
 * @param free 무료구분
 * @param offset
 * @param limit
 */
export const getLiveAllChannels = ({ offset = 0, limit = 999, orderby = 'new', timeStamp }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_LIVE_ALL_CHANNELS_CF, { contenttype: 'channel', offset, limit, orderby, timeStamp }),
    method: HTTP_METHOD_GET
  })
}
export const getLiveRecommendChannels = (params) => {
  return apiRequest({
    url: applyQueryString(URL_GET_LIVE_RECOMMEND_CHANNELS_CF, params),
    method: HTTP_METHOD_GET
  })
}

export const getAllClipList = ({ contentid = '', programid = '', offset = 0, limit = 20, orderby = 'new' }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_CLIP_CONTENTS_CF, { contentid, programid, offset, limit, orderby }),
    method: HTTP_METHOD_GET
  })
}

/**
 * Live 채널 상세정보를 조회한다.
 * @param channelid 채널 ID
 */
export const getLiveChannelsDetail = ({ channelid }) => {
  return apiRequest({
    url: applyPath(URL_GET_LIVE_CHANNELS_DETAIL, channelid),
    method: HTTP_METHOD_GET
  })
}
/**
 * 전체 채널 편성표 목록을 조회한다.
 * @param genre 채널장르
 * @param startdatetime 편성표 조회 시작 시각 (2017-09-02 10:00)
 * @param enddatetime 편성표 조회 종료 시각 (2017-09-03 12:00)
 * @param offset 시작 레코드 번호 [0]
 * @param limit 한번에 가져오는 데이터 숫자 [5]
 */
export const getLiveEpgs = ({ genre, startdatetime, enddatetime, offset, limit }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_LIVE_EPGS, { genre, startdatetime, enddatetime, offset, limit }),
    method: HTTP_METHOD_GET
  })
}

/**
 * 특정 채널 편성표 목록을 조회한다.
 * @param startdatetime 편성표 조회 시작 시각 (2017-09-02 10:00)
 * @param enddatetime 편성표 조회 종료 시각 (2017-09-03 12:00)
 * @param offset 시작 레코드 번호 [0]
 * @param limit 한번에 가져오는 데이터 숫자 [5]
 * @param orderby 정렬순서 [new(최신순), old(과거순)]
 */
export const getLiveEpgsChannels = (startdatetime, enddatetime, offset, limit, orderby) => {
  return apiRequest({
    url: applyQueryString(URL_GET_LIVE_EPGS_CHANNELS, { startdatetime, enddatetime, offset, limit, orderby }),
    method: HTTP_METHOD_GET
  })
}

/**
 * 특정 채널 편성표 목록을 조회한다.
 * @param channelid 채널 ID
 * @param startdatetime 편성표 조회 시작 시각 (2017-09-02 10:00)
 * @param enddatetime 편성표 조회 종료 시각 (2017-09-03 12:00)
 * @param offset 시작 레코드 번호 [0]
 * @param limit 한번에 가져오는 데이터 숫자 [5]
 * @param orderby 정렬순서 [new(최신순), old(과거순)]
 */
export const getLiveEpgsChannelsDetail = ({ channelid, startdatetime, enddatetime, offset, limit, orderby }) => {
  return apiRequest({
    url: applyQueryString(applyPath(URL_GET_LIVE_EPGS_CHANNELS_DETAIL, channelid), {
      startdatetime,
      enddatetime,
      offset,
      limit,
      orderby
    }),
    method: HTTP_METHOD_GET
  })
}

/**
 * Live 장르별 채널 목록을 조회한다.
 * @param free 무료 구분 [all(전체), y(무료만), n(유료만)]
 */
export const getLiveGenreChannels = ({ free }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_LIVE_GENRE_CHANNELS, { free }),
    method: HTTP_METHOD_GET
  })
}

/**
 * Live 채널 목록을 조회한다.
 * @param genre 장르구분
 * @param type 종류 [all, video, audio]
 * @param free 무료 구분 [all(전체), y(무료만), n(유료만)]
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 */
export const getLivePopularChannels = ({ genre, type, free, offset, limit }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_LIVE_POPULAR_CHANNELS, { genre, type, free, offset, limit }),
    method: HTTP_METHOD_GET
  })
}

/**
 * 해당 계정에 속한 사용가능한 프로필 리스트을 갖고 온다.
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 * @param orderby 정렬순서 [new(최신순), old(과거순)]
 */
export const getUserProfileList = ({ offset, limit, orderby }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_PROFILES_ELYSIUM, { offset, limit, orderby }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 프로필 이미지 변경 시 이미지 목록을 갖고 온다.
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 * @param orderby 정렬순서 [new(최신순), old(과거순)]
 */
export const getProfilesImages = ({ offset, limit, orderby }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_PROFILE_IMAGE_LIST_ELYSIUM, { offset, limit, orderby }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 프로필 상세 정보을 갖고 온다.
 * @param profileid 프로필 고유 ID
 */
export const getProfilesDetail = ({ profileid }) => {
  return apiRequest({
    url: applyPath(URL_GET_PROFILES_ELYSIUM, profileid),
    method: HTTP_METHOD_GET
  })
}
/**
 * 특정 사용자의 회원정보를 갖고 온다.
 */
export const getUser = () => {
  return apiRequest({
    url: URL_GET_USER,
    method: HTTP_METHOD_GET
  })
}
/**
 * 특정 사용자의 1:1문의 내역
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 * @param orderby 정렬순서 [new(최신순), old(과거순)]
 */
export const getUserQna = ({ offset, limit, orderby }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_USER_QNA, { offset, limit, orderby }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 특정 사용자의 1:1문의 내역을 갖고 온다.
 * @param qnaid 게시판 번호
 */
export const getUserQnaDetail = ({ qnaid }) => {
  return apiRequest({
    url: applyPath(URL_GET_USER_QNA_DETAIL, qnaid),
    method: HTTP_METHOD_GET
  })
}
/**
 * 영화 전체 목록
 * @param genre 장르코드
 * @param country 국가코드 [all]
 * @param sptheme 스페셜 테마 [all, playy]
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 * @param orderby 정렬순서 [update(업데이트 순), release(개봉일 순), title(가나다 순), viewtime(시청시간 순),
 * paid(단건판매 순)]
 */
export const getMovieContents = ({ genre, country, sptheme, offset, limit, orderby }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_MOVIE_CONTENTS, { genre, country, sptheme, offset, limit, orderby }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 특정 영화 상세 정보
 * @param movieid 영화 ID
 */
export const getMovieContentsDetail = ({ movieid }) => {
  return apiRequest({
    url: applyPath(URL_GET_MOVIE_CONTENTS_DETAIL, movieid),
    method: HTTP_METHOD_GET
  })
}
/**
 * 관련 movie 콘텐츠 목록
 * - 시청이력 기반 (복수)
 * - 출연자정보 기반 (복수)
 * - 연관태그 기반 (복수)
 * @param movieid 영화 movieid
 * @param type 영상 구분 [pre(예고편/관련영상), add(부가영상)]
 */
export const getMovieRelatedContents = ({ movieid = '', offset = 0, limit = 20 }) => {
  return apiRequest({
    url: applyQueryString(`${URL_GET_MOVIE_RELATED_CONTENTS}/${movieid}/contents`, { offset, limit }),
    method: HTTP_METHOD_GET
  })
}

export const getMovieSeriesContents = ({ movieid }) => {
  const path = `${URL_GET_MOVIE_SERIES_CONTENTS}/${movieid}/contents`
  return apiRequest({
    url: path,
    method: HTTP_METHOD_GET
  })
}

/**
 * 멀티 콘텐츠 목록 (섹션별)을 리턴 한다.
 * @param menu 사용할 화면 [main, live, vod, movie, clip]
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 */
export const getMultiSections = ({ menu, offset, limit }) => {
  return apiRequest({
    url: applyQueryString(applyPath(URL_GET_MULTISECTIONS, menu), { offset, limit }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 사용자에게 충전된 코인 목록
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 * @param orderby 정렬순서 [new(최신순), old(과거순)]
 */
export const getMycoinListCharged = ({ offset, limit, orderby }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_MYCOIN_LIST_CHARGED, { offset, limit, orderby }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 사용자가 모두 사용하거나 만료되어 사용할 수 없는 코인 목록
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 * @param orderby 정렬순서 [new(최신순), old(과거순)]
 */
export const getMycoinListExpired = ({ offset, limit, orderby }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_MYCOIN_LIST_EXPIRED, { offset, limit, orderby }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 사용자가 보유한(사용가능한) 코인 요약 정보
 */
export const getMycoinSummary = () => {
  return apiRequest({
    url: URL_GET_MYCOIN_SUMMARY,
    method: HTTP_METHOD_GET
  })
}

/**
 * 보유한 쿠폰 목록
 * 사용가능/만료 쿠폰 표시 (만료 쿠폰은 3개월까지만 표시)
 * @param coupontype 쿠폰구분 [all, voucher(이용권), sale(할인)]
 * @param status 상태구분 [all, y(사용가능), n(만료)]
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 * @param orderby 정렬순서 [new(최신순), old(과거순)]
 */
export const getMyCouponsList = ({ coupontype, status, offset, limit, orderby }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_MYCOUPONS_LIST, { coupontype, status, offset, limit, orderby }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 구매한 단건 콘텐츠 목록(BROADCAST, 영화)을 조회한다. 구매일시 최신순으로 정렬
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 */
export const getMypurchaseContentsItem = ({ offset, limit, dboption }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_MYPURCHASE_CONTENTS_ITEM, { offset, limit, dboption }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 구매한 패키지 목록(BROADCAST, 영화)을 조회한다. 구매일시 최신순으로 정렬
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 */
export const getMypurchaseContentsPackage = ({ offset, limit, dboption }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_MYPURCHASE_CONTENTS_PACKAGE, { offset, limit, dboption }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 사용자가 구매한 상품 목록
 * @param startdate 조회 시작일시 (미 입력 시 현재시각-3개월)
 * @param enddate 조회 종료일시 (미 입력 시 현재 시각)
 * @param producttype 상품구분 [item(단건개별), package(단건패키지), pass(정액제), coin(코인), all(전체)]
 * @param autopayment 자동결제 여부 [y(자동결제), n(단건결제), all(전체)]
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 * @param orderby 정렬순서 [new(최신순), old(과거순)]
 */
export const getMypurchaseProducts = ({ startdate, enddate, producttype, autopayment, offset, limit, orderby }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_MYPURCHASE_PRODUCTS, {
      startdate,
      enddate,
      producttype,
      autopayment,
      offset,
      limit,
      orderby
    }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 자동결제 해지 시 프로모션 대상 여부를 확인함
 */
export const getMypurchasePassCancel = ({ userserviceid }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_MYPURCHASE_PASS_CANCEL, { userserviceid }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 자동결제 해지 시 프로모션 대상 여부를 확인함
 */
export const getMypurchasePassPromotion = () => {
  return apiRequest({
    url: URL_GET_MYPURCHASE_PASS_PROMOTION,
    method: HTTP_METHOD_GET
  })
}
/**
 * 자동결제 해지 시 프로모션 대상 여부를 확인함
 */
export const getMypurchasePassPromotionContinue = () => {
  return apiRequest({
    url: URL_GET_MYPURCHASE_PASS_PROMOTION_CONTINUE,
    method: HTTP_METHOD_GET
  })
}
/**
 * LNB 메뉴 내 중단영역 표시 항목을 노출한다.
 */
export const getMySummary = () => {
  return apiRequest({
    url: URL_GET_MY_SUMMARY,
    method: HTTP_METHOD_GET
  })
}
/**
 * 사용자의 시청 콘텐츠 목록
 * @param contenttype 콘텐츠 구분 [all, vod, movie]
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 * @param orderby 한번에 가져오는 데이터 숫자
 */
export const getMyviewContents = ({ contenttype, offset, limit, orderby, image }) => {
  return apiRequest({
    url: applyQueryString(getDomainWithPrefix(getDomainWithWordPrefix('my', URL_GET_MYVIEW_CONTENTS)),
      { contenttype, offset, limit, orderby, image }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 특정 위치의 노출용 복수 배너
 * @param bannerid 배너 위치에 따른 배너ID [홈화면 팝업 배너 = home_popup 등]
 */
export const getUiserviceBannerMulti = ({ bannerid }) => {
  return apiRequest({
    url: applyPath(URL_GET_UISERVICE_BANNER_MULTI, bannerid),
    method: HTTP_METHOD_GET
  })
}
/**
 * 특정 위치의 노출용 단일 배너
 * @param bannerid 배너 위치에 따른 배너ID [홈화면 팝업 배너 = home_popup 등]
 */
export const getUiserviceBannerSingle = ({ bannerid }) => {
  return apiRequest({
    url: applyPath(URL_GET_UISERVICE_BANNER_SINGLE, bannerid),
    method: HTTP_METHOD_GET
  })
}
// /**
//  * 공지사항 목록을 조회한다. (고정글 3건만 조회) -> deprecated 23/07/11 :getUiserviceNotices -> getNotice
//  * @param type 종류 [all, service, contents]
//  */
// export const getUiserviceNotices = ({ type }) => {
//   return apiRequest({
//     url: applyQueryString(URL_GET_UISERVICE_NOTICES, { type }),
//     method: HTTP_METHOD_GET
//   })
// }
/**
 * 좋아요 한 채널
 * @param contenttype 컨텐츠 구분 (progrma, movie, channel)
 * @param offset
 * @param limit
 */
// export const getUiserviceZzim = ({ contenttype, offset, limit }) => {
//   return apiRequest({
//     url: applyQueryString(applyPath(URL_GET_UISERVICE_ZZIM, contenttype), { offset, limit }),
//     method: HTTP_METHOD_GET
//   })
// }
/**
 * 고객센터 공지사항 목록을 조회한다.
 * @param type 공지 종류 [all(전체), service(서비스), contents(콘텐츠)]
 * @param top 최상단 고정글 구분 [all(전체), y(고정글만), n(고정글제외)]
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 * @param orderby 정렬순서 [new(최신순), old(과거순)]
 */
export const getNotices = ({ type, top, offset, limit, orderby }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_NOTICES, { type, top, offset, limit, orderby }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 고객센터 공지사항 내용을 조회한다.
 * @param noticeid 읽어올 글 번호
 */
export const getNoticesDetail = ({ noticeid }) => {
  return apiRequest({
    url: applyPath(URL_GET_NOTICES_DETAIL, noticeid),
    method: HTTP_METHOD_GET
  })
}
/**
 * 고객센터 공지사항 목록을 조회한다.
 * @param type 공지 종류 [all(전체), service(서비스), contents(콘텐츠)]
 * @param subtype 공지 종류 (Sub)
 * @param top 최상단 고정글 구분 [all(전체), y(고정글만), n(고정글제외)]
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 * @param orderby 정렬순서 [new(최신순), old(과거순)]
 */
export const getNoticesCompanyInfoBoard = ({ type, subtype, top, offset, limit, orderby }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_NOTICES_COMPANY_INFO_BOARD, { type, subtype, top, offset, limit, orderby }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 고객센터 공지사항 내용을 조회한다.
 * @param type 회사소개 종류
 * @param subtype 회사소개 종류 (Sub)
 * @param boardid 읽어올 글 번호
 */
export const getNoticesCompanyInfoBoardDetail = ({ type, subtype, boardid }) => {
  return apiRequest({
    url: applyQueryString(applyPath(URL_GET_NOTICES_COMPANY_INFO_BOARD_DETAIL, boardid), { type, subtype }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 웨이브온인지 확인한다. 웨이브온일 경우 웨이브온 관련 정보를 반환한다.
 */
export const getPooqzoneCheck = () => {
  return apiRequest({
    url: URL_GET_POOQZONE_CHECK,
    method: HTTP_METHOD_GET
  })
}
/**
 * 웨이브온 성인콘텐츠 시청 시 pincode 체크용
 * @param adultpincode 웨이브온 성인콘텐츠 시청 확인용 코드 (숫자 4자리)
 */
export const getPooqzoneAdult = ({ adultpincode }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_POOQZONE_ADULT, { adultpincode }),
    method: HTTP_METHOD_GET
  })
}

/**
 * 특정 패키지에 포함된 콘텐츠 콘텐츠 리스트
 * @param productid productid
 * @param contenttype 상품에 포함된 콘텐츠 중 목록을 노출할 콘텐츠 타입 [all, vod, movie]
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 */
export const getPurchaseProductContents = ({ productid, contenttype, offset, limit }) => {
  return apiRequest({
    url: applyQueryString(applyPath(URL_GET_PURCHASE_PRODUCT_CONTENTS, productid), { contenttype, offset, limit }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 특정 콘텐츠의 구매가능한 상품 목록 (플레이어 화면에서 사용)
 * @param contentid ∂콘텐츠 ID [영화 = movieid]
 * @param contenttype 콘텐츠 타입 [라이브 = live, vod = vod, 영화 = movie]
 * @param vouchertype 이용권 구분 [추천 이용권 = voucher, 제휴이용권 = partner, 전체 = all, 사용중인 이용권 포함 = use (영화 상세화면용), 영화 구매하기 팝업 = movie]
 */
export const getPurchaseProducts = ({ cpid, channelid, programid, contentid, contenttype, vouchertype, isplayy, recommendvoucher, downloadyn }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_PURCHASE_PRODUCTS, {
      cpid,
      channelid,
      programid,
      contentid,
      contenttype,
      vouchertype,
      isplayy,
      recommendvoucher,
      downloadyn
    }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 특정 콘텐츠의 구매가능한 상품 목록 (플레이어 화면에서 사용)
 */
export const getPurchaseProductsUpsell = () => {
  return apiRequest({
    url: URL_GET_PURCHASE_PRODUCTS_UPSELL,
    method: HTTP_METHOD_GET
  })
}
/**
 * 멀티 콘텐츠 목록 (콘텐츠별)을 리턴 한다. 멀티섹션 API와 출력 동일
 * @param movieid 추천대상 영화id
 */
export const getRecommendationMovie = ({ movieid }) => {
  return apiRequest({
    url: applyPath(URL_GET_RECOMMENDATION_MOVIE, movieid),
    method: HTTP_METHOD_GET
  })
}
/**
 * 멀티 콘텐츠 목록 (콘텐츠별)을 리턴 한다. 멀티섹션 API와 출력 동일
 * @param contentid 추천대상 콘텐츠id
 */
export const getRecommendationVod = ({ contentid }) => {
  return apiRequest({
    url: applyPath(URL_GET_RECOMMENDATION_VOD, contentid),
    method: HTTP_METHOD_GET
  })
}
/**
 * 검색결과 목록을 조회한다.
 * @param type 검색할 콘텐츠 타입 [all(전체), live, program, vod, movie, clip, snapshot(장면검색), theme(테마), faq, notice(공지사항)]
 * @param keyword 검색할 키워드
 * @param offset 시작 레코드 번호 [0]
 * @param limit 한번에 가져오는 데이터 숫자 [5]
 * @param orderby 정렬순서 [new(최신순), score(정확도순)]
 * @param isplayymovie 웨이브온에서 사용, 영화 숨김처리 [y, n]
 */
// 물어보기
export const getSearch = ({ type, keyword, offset, limit, orderby = 'score', isplayymovie = 'y' }) => {
  if (!checkAcceptableString(keyword)) {
    return new Promise((resolve) => {
      resolve(emptySearchFaqList)
    })
  } else {
    return apiRequest({
      url: applyQueryString(URL_GET_SEARCH, { type, keyword, offset, limit, orderby, isplayymovie }),
      method: HTTP_METHOD_GET
    })
  }
}
/**
 * 3.1 검색 API 멀티 섹션 리스트
 * @param limit
 * @param offset
 * @param orderby
 * @param type
 * @param keyword
 * @param requestId
 * @returns {boolean}
 */

const checkAcceptableString = (keyword = '') => {
  const chk1 = removePrefixEmptyString(keyword)
  const chk2 = keyword.trim()
  const isString = str => typeof str === 'string'
  const isZeroLength = str => str.length === 0
  return (isString(chk1) && isString(chk2) && !isZeroLength(chk1) && !isZeroLength(chk2))
}

export const getSearchMultiSection = ({ limit = '20', offset = '0', orderby = 'score', type = 'all', keyword = '', requestId = '', mtype = 'all', version = 2 }) => {
  if (!checkAcceptableString(keyword)) {
    return new Promise((resolve, reject) => {
      resolve(emptyBandResult)
    })
  } else {
    return apiRequest({
      url: applyQueryString(URL_GET_SEARCH_MULTI_SECTION, { limit, offset, orderby, type, keyword, mtype, version }),
      method: HTTP_METHOD_GET
    })
  }
}
export const getSearchList = ({ limit = '20', offset = '0', orderby = 'score', type = 'all', keyword = '', requestId = '', mtype = '', version = 1, transactionkey = '' }) => {
  if (!checkAcceptableString(keyword)) {
    return new Promise((resolve, reject) => {
      resolve(emptyListResult)
    })
  } else {
    return apiRequest({
      url: applyQueryString(URL_GET_SEARCH_LIST, { limit, offset, orderby, type, keyword, mtype, version, transactionkey }),
      method: HTTP_METHOD_GET
      // requestId: requestId
    })
  }
}

/**
 * FAQ 검색결과를 조회한다.
 * @param type /filters API에서 호출
 * @param keyword 검색할 키워드
 * @param offset 시작 레코드 번호 [0]
 * @param limit 한번에 가져오는 데이터 숫자 [5]
 * @param orderby 정렬순서 [new(최신순), old(과거순)]
 */
export const getSearchFaq = ({ type, keyword = '', offset, limit, orderby }) => {
  if (!checkAcceptableString(keyword)) {
    return new Promise((resolve) => {
      resolve(emptySearchFaqList)
    })
  } else {
    return apiRequest({
      url: applyQueryString(URL_GET_SEARCH_FAQ, { type, keyword, offset, limit, orderby }),
      method: HTTP_METHOD_GET
    })
  }
}
/**
 * 자동완성 검색 키워드
 * 프로그램/영화 제목 중 정확도 순으로 정확도순 최대 10개 표시 (BROADCAST 우선 채우고 10개에서 부족한 만큼 영화에서 채움)
 * @param keyword 검색어
 * @param isplayymovie 웨이브온에서 사용, 영화 숨김처리 [y, n]
 * @param type 영화, 프로그램 통합 타입
 */
export const getSearchInstanceKeywords = ({ keyword, isplayymovie, type = 'all' }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_SEARCH_INSTANCE_KEYWORDS, { keyword, isplayymovie, type }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 공지사항 검색결과를 조회한다.
 * @param type 공지 종류 [전체 = all,서비스 = service,콘텐츠 = contents]
 * @param keyword 검색할 키워드
 * @param offset 시작 레코드 번호 [0]
 * @param limit 한번에 가져오는 데이터 숫자 [5]
 * @param orderby 정렬순서 [new(최신순), old(과거순)]
 */
export const getSearchNotice = ({ type, keyword, offset, limit, orderby }) => {
  if (keyword) {
    return apiRequest({
      url: applyQueryString(URL_GET_SEARCH_NOTICE, { type, keyword, offset, limit, orderby }),
      method: HTTP_METHOD_GET
    })
  }
}
/**
 * 인기 검색어 목록
 * @param contenttype 검색어 종류 [vod, live, movie]
 */
export const getSearchPopularKeywords = ({ contenttype }) => {
  return apiRequest({
    url: (contenttype === 'movie'
      ? applyPath(URL_GET_SEARCH_POPULAR_KEYWORDS, contenttype)
      : applyQueryString(applyPath(URL_GET_SEARCH_POPULAR_KEYWORDS, 'vod'), { contenttype })),
    method: HTTP_METHOD_GET
  })
}
/**
 * 추천 검색어 목록
 */
export const getSearchRecommendKeywords = () => {
  return apiRequest({
    url: applyQueryString(URL_GET_SEARCH_RECOMMEND_KEYWORDS),
    method: HTTP_METHOD_GET
  })
}
/**
 * 다운로드
 * @param contenttype 컨텐츠 구분 (live, vod, movie, clip, timemachine, onairvod)
 * @param contentid 재생할 콘텐츠 ID live(channelid), 프로그램(programid), vod(contentid), 영화(movieid), 클립(clipid)
 * @param action 스트리밍 방식 (hls, dash, progressive, download)
 * @param quality 영상 화질구분 (360p, 480p, 720p, 1080p, 2160p, default)
 * @param guid 기기 식별값 (별도 API에서 받음)
 * @param authtype url 인증방식 (signed url = url, http header 인증 = cookie)
 * @param lastplayid 기존에 저정된 재생 playid
 * @param isabr adaptive streaming 여부 (y, n)
 * @param ishevc hevc 여부 (y, n)
 */
export const getStreaming = ({ contenttype, contentid, action, quality, guid, authtype, lastplayid, isabr, ishevc }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_STREAMING, {
      contenttype,
      contentid,
      action,
      quality,
      guid,
      authtype,
      lastplayid,
      isabr,
      ishevc
    }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 태그 검색 초기화면에서 사용하는 태그 목록을 조회한다.
 * @param type 대상 화면 [BROADCAST 검색 = vodsearch, 영화 검색 = moviesearch]
 */
export const getTagsGroups = ({ type }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_TAGS_GROUPS, { type }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 태그 검색 초기화면에서 사용하는 태그 목록을 조회한다.
 * @param type 대상 화면 [방송VOD = vod, 영화 = movie, BROADCAST 홈 = vodhome, 검색결과 없음 = nonesearchresult]
 * @param contentid 방송VOD/영화 태그일 경우에만 입력 (vod홈 / 검색결과 없음 = none)
 * @param tag 선택한 태그
 */
export const getTagsList = ({ type, contentid, tag }) => {
  return apiRequest({
    url: applyQueryString(URL_TAGS_LIST, { type, contentid, tag }),
    method: HTTP_METHOD_GET
  })
}

/**
 * 검색 히스토리가 없을때 추천 검색어
 */
export const getRecommendList = () => {
  return apiRequest({
    url: URL_GET_SEARCH_RECOMMEND_LIST,
    method: HTTP_METHOD_GET
  })
}

/**
 * 약관 및 정책 내용을 조회한다.
 * @param type 약관 및 정책 종류 [service(서비스 이용약관), payment(유료상품 이용약관), privacy(개인정보 처리방침), youth(청소년 보호정책), pooqzone(웨이브온 이용약관)]
 * @param version 약관 버전을 형식에 맞게 입력 예) 1.1.1, last
 */
export const getTerms = ({ type, version }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_TERMS, { type, version }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 테마 목록을 조회한다.
 * @param contenttype 콘텐츠 타입 [all, live, vod, movie, clip]
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 * @param orderby 정렬순서 [rank(지정순), new(최신순), old(과거순)]
 */
export const getThemes = ({ contenttype, offset, limit, orderby }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_THEMES, { contenttype, offset, limit, orderby }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 특정 테마의 콘텐츠 리스트
 * @param themeid 콘텐츠 타입 [replay(BROADCAST 메뉴 내 다시보고 싶은), vod(BROADCAST 메뉴 내 에디터Pick),
 * movie(영화 메뉴 내 에디터Pick), clip(TV컷 메뉴 내 에디터Pick)]
 * @param contenttype 시작 레코드 번호
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 */
export const getThemesContents = ({ themeid, contenttype, offset, limit }) => {
  return apiRequest({
    url: applyQueryString(applyPath(URL_GET_THEMES_CONTENTS, themeid), { contenttype, offset, limit }),
    mehtod: HTTP_METHOD_GET
  })
}
/**
 * 테마 목록 (메뉴별)을 리턴 한다.
 * @param menu 콘텐츠 타입 [replay(BROADCAST 메뉴 내 다시보고 싶은), vod(BROADCAST 메뉴 내 에디터Pick),
 * movie(영화 메뉴 내 에디터Pick), clip(TV컷 메뉴 내 에디터Pick)]
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 */
export const getThemesList = ({ menu, offset, limit }) => {
  return apiRequest({
    url: applyQueryString(applyPath(URL_GET_THEMES_LIST, menu), { offset, limit }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 특정 콘텐츠가 포함된 테마 목록을 조회한다.
 * @param contenttype 콘텐츠 타입 [live(라이브), program(프로그램), vod(vod), movie(영화), clip(클립)]
 * @param contentid 조회할 콘텐츠ID
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 * @param orderby 정렬순서 [rank(지정순), new(최신순), old(과거순)]
 */
export const getThemesRelated = ({ contenttype, contentid, offset, limit, orderby }) => {
  return apiRequest({
    url: applyQueryString(applyPath(URL_GET_THEMES_RELATED, contentid), { contenttype, offset, limit, orderby }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 특정 테마 상세 정보
 * @param themeid 테마 고유ID
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 */
export const getThemesDetail = ({ themeid, offset, limit }) => {
  return apiRequest({
    url: applyQueryString(applyPath(URL_GET_THEMES_DETAIL, themeid), { offset, limit }),
    method: HTTP_METHOD_GET
  })
}
/**
 * BROADCAST 프로그램 전체 목록을 조회한다.
 * @param onair 조회할 콘텐츠ID
 * @param genre 조회할 콘텐츠ID
 * @param subgenre 조회할 콘텐츠ID
 * @param channel 조회할 콘텐츠ID
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 * @param orderby 정렬순서 [new(최신순), old(과거순), title(제목순)]
 */
export const getVodAllprograms = ({ onair, genre, subgenre, channel, offset, limit, orderby }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_VOD_ALLPROGRAMS, { onair, genre, subgenre, channel, offset, limit, orderby }),
    method: HTTP_METHOD_GET
  })
}

/**
 * VOD landing info 를 조회한다.
 * @param programid
 * @param contentid
 * @param history
 */
export const getVodLandingInfo = ({ programid = '', contentid = '', history = '' }) => {
  return apiRequest({
    url: contentid
      ? applyQueryString(URL_GET_VOD_LANDING_INFO, { contentid })
      : applyQueryString(URL_GET_VOD_LANDING_INFO, { programid, history }),
    method: HTTP_METHOD_GET
  })
}

/**
 * 특정 BROADCAST 콘텐츠 (회차) 상세 정보를 갖고 온다.
 * @param contentid 조회할 콘텐츠ID
 */
export const getVodContentsDetail = ({ contentid }) => {
  return apiRequest({
    url: applyPath(URL_GET_VOD_CONTENTS_DETAIL, contentid),
    method: HTTP_METHOD_GET
  }).then((response) => {
    if (_.get(response, ['data', 'contentid'], '') === '') {
      return Promise.reject(new Error(''))
    }
      return response
  })
}

/**
 * VOD Episode 리스트를 가져 온다. (콘텐츠 상세 신규 api)
 * @param path landing api 에서 내려온 값
 * @param limit
 * @param offset
 * @param orderby
 * @param programid // path 가 없으면 program id 로 조회 (엣지 케이스 대응)
 * @returns {AxiosPromise}
 */
export const getVodEpisodeList = ({ path = '', limit = 10, offset = 0, orderby = 'new', programid = '' }) => {
  // landing api 에서 내려주는 path 가 있을 경우 path 로 / 없다면 program id 로 조회
  const URL = (path && path !== '')
    ? applyQueryString(`${API_BASE_URL_FROZEN}${path}`, { limit, offset, orderby })
    : applyQueryString(`${URL_GET_VOD_EPISODE_LIST}/${programid}/contents`, { limit, offset, orderby })
  return apiRequest({
    url: URL,
    method: HTTP_METHOD_GET
  })
}

/**
 * BROADCAST 전체 콘텐츠 목록을 조회한다. (인기순은 미지원)
 * @param genre 1depth 장르코드 (/filters API 출력값 참조). 미 선택시 all 입력.
 * @param subgenre 서브 장르코드 (/filters API 출력값 참조). 미 선택시 all 입력.
 * @param channel 채널ID
 * @param type VOD구분 [general(일반), onair(On-Air BROADCAST), all(전체)]
 * @param weekday 방영요일 [all, sun, mon, tue, wen, thu, fri, sat]
 * @param free 무료구분 [all(전체), y(무료만), n(유료만)]
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 * @param orderby 정렬순서 [new(최신순), old(과거순), popular(인기순)]
 */
export const getVodNewContents = ({ genre, subgenre, channel, type, weekday, free, offset, limit, orderby }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_VOD_NEW_CONTENTS, {
      genre,
      subgenre,
      channel,
      type,
      weekday,
      free,
      offset,
      limit,
      orderby
    }),
    method: HTTP_METHOD_GET
  })
}
/**
 * BROADCAST 인기 콘텐츠 목록을 조회한다. (시청 데이터로 집계된 콘텐츠만 노출)
 * @param genre 장르코드
 * @param subgenre 서브 장르코드 (/filters API 출력값 참조). 미 선택시 all 입력.
 * @param channel 채널ID
 * @param type VOD구분 [general(일반), onair(On-Air BROADCAST), all(전체)]
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 */
export const getVodPopularContents = ({ genre, subgenre, channel, type, offset, limit }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_VOD_POPULAR_CONTENTS, { genre, subgenre, channel, type, offset, limit }),
    method: HTTP_METHOD_GET
  })
}
/**
 * BROADCAST 프로그램 인기 목록을 조회한다.
 * @param onair 조회할 콘텐츠ID
 * @param genre 조회할 콘텐츠ID
 * @param subgenre 조회할 콘텐츠ID
 * @param channel 조회할 콘텐츠ID
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 */
export const getVodPopularprograms = ({ onair, genre, subgenre, channel, offset, limit }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_VOD_POPULARPROGRAMS, { onair, genre, subgenre, channel, offset, limit }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 특정 프로그램ID를 입력하면 재생할 회차 id를 리턴한다 (마지막 재생한 회차 -> 없을 경우 종영여부 확인 / 종영 -> 1회 / 방영중 -> 마지막 회차)
 * @param programid 시청하는 콘텐츠의 programid
 */
export const getVodProgramsContentid = ({ programid }) => {
  return apiRequest({
    url: applyPath(URL_GET_VOD_PROGRAMS_CONTENTID, programid),
    method: HTTP_METHOD_GET
  })
}
/**
 * 특정 프로그램의 콘텐츠(회차) 목록을 조회한다.
 * @param programid 프로그램 고유코드
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 * @param orderby 정렬순서 [new(최신순), old(과거순), popular(인기순)]
 */
export const getVodProgramsContents = ({ programid, offset, limit, orderby }) => {
  return apiRequest({
    url: (orderby === 'popular'
      ? applyQueryString(applyPath(URL_GET_VOD_PROGRAMS_POPULAR_CONTENTS, programid), { offset, limit })
      : applyQueryString(applyPath(URL_GET_VOD_PROGRAMS_CONTENTS, programid), { offset, limit, orderby })),
    method: HTTP_METHOD_GET
  })
}
/**
 * BROADCAST 추천 멀티밴드
 * @param programID
 * @param contentID
 * @returns {*}
 */
export const getVodRecommendMultiSection = ({ programid, contentid }) => {
  const TYPE = 'DN1'
  // BROADCAST DN1
  // LIVE DY1
  // MOVIE DN2
  // TVCUT DN4
  return apiRequest({
    url: applyQueryString(applyPath(URL_GET_CONTENT_RECOMMEND_LIST, TYPE), { contentid, programid }),
    method: HTTP_METHOD_GET
  })
}
/**
 * LIVE 추천 멀티밴드
 * @param channelid
 * @returns {AxiosPromise}
 */
export const getLiveRecommendMultiSection = ({ channelid, timeStamp }) => {
  const TYPE = 'DY1'
  return apiRequest({
    url: applyQueryString(applyPath(URL_GET_CONTENT_RECOMMEND_LIST, TYPE), { channelid, timeStamp }),
    method: HTTP_METHOD_GET
  })
}

export const getClipRecommendMultiSection = ({ clipid }) => {
  const TYPE = 'DN4'
  return apiRequest({
    url: applyQueryString(applyPath(URL_GET_CONTENT_RECOMMEND_LIST, TYPE), { clipid }),
    method: HTTP_METHOD_GET
  })
}

export const getMovieRecommendMultiSection = ({ movieid }) => {
  const TYPE = 'DN2'
  return apiRequest({
    url: applyQueryString(applyPath(URL_GET_CONTENT_RECOMMEND_LIST, TYPE), { movieid }),
    method: HTTP_METHOD_GET
  })
}

// export const getVodProgramsContents = ({ programid, offset, limit, orderby }) => {
//   return apiRequest({
//     url: applyQueryString(applyPath(URL_GET_VOD_ALL_CONTENT, programid), { offset, limit, orderby }),
//     method: HTTP_METHOD_GET
//   })
// }

/**
 * 관련 BROADCAST
 * @param programid 편성표에 포함된 프로그램ID
 * @param channelid 채널 ID
 * @param offset
 * @param limit
 */
export const getVodRelatedContents = ({ path = '', programid = '', offset = 0, limit = 20 }) => {
  const URL = (path && path !== '')
    ? applyQueryString(`${API_BASE_URL_FROZEN}${path}`, { offset, limit })
    : applyQueryString(applyPath(URL_GET_VOD_RELATED_CONTENTS, `${programid}/contents/related`), { offset, limit })

  return apiRequest({
    url: URL,
    method: HTTP_METHOD_GET
  })
}
/**
 * 사용자의 선호채널(live) / 찜 콘텐츠 목록을 갖고 온다.
 * @param contenttype 콘텐츠 구분 [live, program, movie]
 * @param offset 시작 레코드 번호
 * @param limit 한번에 가져오는 데이터 숫자
 */
export const getZzimContents = ({ contenttype, offset, limit }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_ZZIM_CONTENTS, { contenttype, offset, limit }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 테마 찜 여부 확인
 */
export const getZzimContentsDetail = ({ contentid, contenttype }) => {
  return apiRequest({
    url: applyQueryString(applyPath(URL_GET_ZZIM_DETAIL, contentid), { contenttype }),
    method: HTTP_METHOD_GET
  })
}
/**
 * 다운로드 횟수를 차감한다.
 * @param contenttype 콘텐츠 구분 [vod, movie]
 * @param id 다운로드 카운트 차감할 콘텐츠ID
 * @param quality 영상 화질구분값
 */
export const postDownloads = ({ contenttype, id, quality }) => {
  return apiRequest({
    url: URL_POST_DOWNLOADS,
    method: HTTP_METHOD_POST,
    data: {
      contenttype,
      id,
      quality
    }
  })
}
/**
 * 로그인 로직
 * @param type 로그인 타입 구분 [자동로그인: credential, ID: general, 기기시리얼: machine, 페이스북: facebook, 카카오: kakao, 네이버: naver]
 * @param id 로그인 식별값 [crednetial로그인: crednetial, general로그인: ID, machine로그인: 기기시리얼, facebook로그인: facebook key, kakao로그인: kakao key]
 * @param pushid Push 기기 등록을 위한 Onesignal ID
 * @param password 사용자 password
 * @param profile 프로필 ID
 * @param networktype
 * @param carrier
 * @param mcc
 * @param mnc
 * @param markettype
 */
export const postLogin = async ({ type, id, pushid, password, profile = 0, networktype = '0', carrier = '', mcc = '', mnc = '', markettype = 'generic' }) => {
  if (!pushid) {
    pushid = ''
  }
  if (!profile) {
    profile = ''
  }
  const response = await apiRequest(
    {
      url: URL_POST_LOGIN,
      method: HTTP_METHOD_POST,
      data: {
        type,
        id,
        pushid: '',
        password,
        profile
        // networktype,
        // carrier,
        // mcc,
        // mnc,
        // markettype
      }
    })
  const serviceLocation = await getServiceLocation(_.get(response, ['data', 'credential'], 'none'))
  const locationInfo = _.get(serviceLocation, ['data'], false)
  if (locationInfo) {
    setServiceLocationInfo(locationInfo)
  }
  return response
}

export function getServiceLocation (credential) {
  return axios.get(`${URL_GET_SERVICE_LOCATION}?credential=${credential}&timestamp=` + getUnixTimeStamp(),
    {
      responseType: 'json',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json; charset=utf-8'
      }
    })
}

/**
 * 로그인 아웃
 * @param pushid Push 기기 해제를 위한 Onesignal ID
 */
export const postLogout = ({ pushid = '' }) => {
  return apiRequest({
    url: URL_POST_LOGOUT,
    method: HTTP_METHOD_POST,
    data: {
      pushid
    }
  })
}
/**
 * 프로필 정보를 수정한다.
 * @param profileid 프로필 고유 ID
 * @param imageid /profiles-images API 에서 선택한 이미지 ID, 미입력 시 기존값 유지
 * @param profilename 사용자가 입력한 프로필 이름, 미입력 시 기존값 유지
 */
export const postProfilesDetail = ({ profileid, imageid, profilename }) => {
  return apiRequest({
    url: applyPath(URL_POST_USER_PROFILE_DETAIL_ELYSIUM, profileid),
    method: HTTP_METHOD_POST,
    data: {
      imageid,
      profilename
    }
  })
}
/**
 * 이용권 해지 시 해지 사유를 보냄
 * @param description 해지 사유
 */
export const postUserPurchaseCancel = ({ description }) => {
  return apiRequest({
    url: URL_POST_USER_PURCHASE_CANCEL,
    method: HTTP_METHOD_POST,
    data: {
      description
    }
  })
}
/**
 * 보유 쿠폰 활성화(사용시작). 이용권 쿠폰만 가능
 * @param couponnumber 쿠폰번호 (최대 20자리)
 */
export const postMycouponsActivate = ({ couponnumber }) => {
  return apiRequest({
    url: applyPath(URL_POST_MYCOUPONS_ACTIVATE, couponnumber),
    method: HTTP_METHOD_POST
  })
}
/**
 * 쿠폰 번호 등록하여 보유 쿠폰으로 전환.
 * @param couponnumber 쿠폰번호 (최대 20자리)
 */
export const postMycouponsRegister = ({ couponnumber }) => {
  return apiRequest({
    url: applyPath(URL_POST_MYCOUPONS_REGISTER, couponnumber),
    method: HTTP_METHOD_POST
  })
}
/**
 * 자동결제 상품 해지 / 해지 복원
 * @param productType 이용권 종류 [pass = 이용권, coin = 코인]
 * @param keyId 상태코드를 지정한다 [userServiceId = 이용권 해지/해지복원 시, paymentId = 코인 상품 해지/해지복원 시]
 * @param status 상태코드를 지정한다 [0 = 자동결제 해지, 1 = 자동결제 복원]
 */
export const postMypurchasePassCancel = ({ productType, keyId, status }) => {
  return apiRequest({
    url: URL_POST_MYPURCHASE_PASS_CANCEL,
    method: HTTP_METHOD_POST,
    data: {
      productType,
      keyId,
      status
    }
  })
}
/**
 * 해지 이벤트
 * @param eventType 이벤트 구분 cancelpass = 이용권 해지
 */
export const postMypurchasePassEvent = ({ eventType }) => {
  return apiRequest({
    url: URL_POST_MYPURCHASE_PASS_EVENT,
    method: HTTP_METHOD_POST,
    data: {
      eventType
    }
  })
}
// 웨이브온 인트로 페이지에서 웨이브온에 들어갈 떄 사용하는 API, 사용자에게서 PIN Code 를 입력받아서 보낸다.
/**
 * 웨이브온 크레덴셜 발행
 * @param pooqzoneid 웨이브온 고유ID
 * @param pincode 웨이브온 접속용 pincode (없을 경우 미입력)
 */
export const postPooqzoneLogin = ({ pooqzoneid, pincode }) => {
  return apiRequest({
    url: URL_POST_POOQZONE_LOGIN,
    method: HTTP_METHOD_POST,
    data: {
      pooqzoneid,
      pincode
    }
  })
}
/**
 * 태그 검색결과 목록을 조회한다.
 * @param type 검색할 콘텐츠 타입 [all(전체), live, program, vod, movie]
 * @param searchtags 검색할 태그 (object)
 * @param offset 시작 레코드 번호 [0]
 * @param limit 한번에 가져오는 데이터 숫자 [5]
 * @param orderby 정렬순서 [score, new]
 * @param isplayymovie 웨이브온에서 사용, 영화 숨김처리 [y, n]
 */
// export const postSearchTags = ({ type, searchtags, offset, limit, orderby = 'score', isplayymovie }) => {
//   return apiRequest({
//     url: applyQueryString(URL_POST_TAG_SEARCH, { isplayymovie }),
//     method: HTTP_METHOD_POST,
//     data: {
//       type,
//       offset,
//       limit,
//       orderby,
//       searchtags
//     }
//   })
// }
/**
 * 3.1 API 태그 검색
 * post body -> get queryString
 * orderby, limit, offset, type,
 *
 */
export const postSearchTagBand = ({ limit = '20', offset = '0', orderby = 'score', type = 'all', searchtags, version = 2 }) => {
  return apiRequest({
    url: applyQueryString(URL_POST_TAG_SEARCH_CF_NEW, { orderby, limit, offset, type, version }),
    method: HTTP_METHOD_POST,
    data: { searchtags }
  })
}

/**
 * 3.1 API 태그 검색
 * post body -> get queryString
 * orderby, limit, offset, type,
 *
 */
export const postSearchTagList = ({ limit = '20', offset = '0', orderby = 'score', type = 'all', mtype = '', searchtags, version = 2 }) => {
  return apiRequest({
    url: applyQueryString(URL_POST_TAG_SEARCH_CF, { orderby, limit, offset, type, mtype, version }),
    method: HTTP_METHOD_POST,
    data: { searchtags }
  })
}

/**
 * vod, movie에서 넘어온 태그 검색결과 목록을 조회한다.
 * @param type 검색할 콘텐츠 타입 [all(전체), live, program, vod, movie]
 * @param searchtags 검색할 태그 (object)
 * @param keyword 검색할 태그명
 * @param offset 시작 레코드 번호 [0]
 * @param limit 한번에 가져오는 데이터 숫자 [5]
 */
// export const postSearchEtcTags = ({ type, searchtags, keyword, offset, limit }) => {
//   return apiRequest({
//     url: URL_POST_TAG_SEARCH,
//     method: HTTP_METHOD_POST,
//     data: {
//       type,
//       searchtags,
//       keyword,
//       offset,
//       limit
//     }
//   })
// }
/**
 * 사용자의 선호채널(live) / 찜 콘텐츠 등록을 한다.
 * @param contentid 등록할 콘텐츠ID [channelid, programid, movieid]
 * @param contenttype 콘텐츠 구분 [live, program, movie]
 * @param addalarm 알람 추가여부. 파라미터 미입력 시 추가 (optional),
 * contenttype 값에 따라 알람 종류가 다르다. live = 없음, program = 업로드 알람,
 * movie = 예약 구매 오픈, 할인/이벤트 알람
 */
export const postZzimContentsDetail = ({ contentid, contenttype, addalarm }) => {
  return apiRequest({
    url: applyPath(URL_POST_ZZIM_DETAIL, contentid),
    method: HTTP_METHOD_POST,
    data: {
      contenttype,
      addalarm
    }
  })
}
export const postZzimBaseball = ({ alarmtype, gameid, contentid, image, contenttitle, channeltitle, releasedatetime, isForce = 'N' }) => {
  return apiRequest({
    url: URL_POST_ZZIM_BASEBALL,
    method: HTTP_METHOD_POST,
    data: {
      alarmtype,
      gameid,
      contentid,
      image,
      contenttitle,
      channeltitle,
      releasedatetime,
      isForce
    }
  })
}
export const deleteZzimBaseball = ({ alarmtype, contentid, releasedatetime }) => {
  return apiRequest({
    url: URL_DELETE_ZZIM_BASEBALL,
    method: HTTP_METHOD_DELETE,
    data: {
      alarmtype,
      contentid,
      releasedatetime
    }
  })
}
/**
 * 다운로드 목록을 삭제한다.
 * @param id 삭제할 다운로드 목록 고유ID
 */
export const deleteDownloads = ({ id }) => {
  return apiRequest({
    url: URL_DELETE_DOWNLOADS,
    method: HTTP_METHOD_DELETE,
    data: {
      id
    }
  })
}
/**
 * 특정 사용자의 특정 1:1문의 내역을 비노출한다.
 * @param qnaid 삭제할 다운로드 목록 고유ID
 */
export const deleteUserQna = ({ qnaid }) => {
  return apiRequest({
    url: URL_DELETE_USER_QNA,
    method: HTTP_METHOD_DELETE,
    data: {
      qnaid
    }
  })
}
/**
 * 구매한 상품 목록을 숨긴다.
 * @param paymentId 삭제할 콘텐츠의 paymentid
 */
export const deleteMypurchaseContentsItem = ({ paymentId }) => {
  return apiRequest({
    url: URL_DELETE_MYPURCHASE_CONTENTS,
    method: HTTP_METHOD_DELETE,
    data: {
      paymentId
    }
  })
}
export const deleteAllMypurchasePackage = () => {
  return apiRequest({
    url: URL_ALL_DELETE_MYPURCHASE_PACKAGE,
    method: HTTP_METHOD_DELETE
  })
}
/**
 * 구매한 상품 비노출 (복수 지정 가능)
 * @param userserviceid 데이터의 userserviceid 값
 */
export const deleteMypurchaseProducts = ({ userserviceid }) => {
  return apiRequest({
    url: URL_DELETE_MYPURCHASE_PRODUCTS,
    method: HTTP_METHOD_DELETE,
    data: {
      userserviceid
    }
  })
}
/**
 * 사용자의 시청 이력 삭제
 * @param contenttype 콘텐츠 구분 [all, vod, movie]
 * @param contentinfo 콘텐츠 정보. 복수 입력 가능 - vod = contentid, 영화 = movieid, 클립 = clipid
 */
export const deleteMyviewContents = ({ contenttype, contentinfo }) => {
  return apiRequest({
    url: getDomainWithPrefix(getDomainWithWordPrefix('my', URL_DELETE_MYVIEW_CONTENTS)),
    method: HTTP_METHOD_DELETE,
    data: {
      contenttype,
      contentinfo
    }
  })
}
export const deleteMyviewAllContents = ({ contenttype, updatevalue = 'y' }) => {
  return apiRequest({
    url: applyQueryString(getDomainWithPrefix(getDomainWithWordPrefix('my', URL_ALL_DELETE_MYVIEW_CONTENTS)),
      { contenttype, updatevalue }),
    method: HTTP_METHOD_DELETE
  })
}
export const deleteMyviewAllDownload = ({ contenttype }) => {
  return apiRequest({
    url: applyQueryString(URL_ALL_DELETE_DOWNLOAD, { contenttype }),
    method: HTTP_METHOD_DELETE
  })
}
export const deleteAllPurchaseVoucher = () => {
  return apiRequest({
    url: URL_ALL_DELETE_PURCHASE_VOUCHER,
    method: HTTP_METHOD_DELETE
  })
}
export const deleteZzimContents = ({ contenttype, contentids, delalarm }) => {
  return apiRequest({
    url: URL_DELETE_ZZIM_CONTENTS,
    method: HTTP_METHOD_DELETE,
    data: {
      contenttype,
      contentids,
      delalarm
    }
  })
}

const sendEventObjectConverter = (eventObject) => {
  const params = {}
  _.get(eventObject, 'bodylist', []).forEach((body) => {
    const bodyKeyValueArr = body.split(':')
    const key = bodyKeyValueArr[0]
    params[key] = bodyKeyValueArr[1]
    if (key === 'timestamp') {
      params[key] = getTimeStamp()
    }
  })
  return params
}

let eventObjectList = []
export const sendOnDisplayLog = (eventObject) => {
  const requestFn = (objectList) => {
    const URL = 'https://uievent3.wavve.com/uievent'
    return apiRequest({
      url: URL,
      method: HTTP_METHOD_POST,
      headers: { 'Content-Type': 'text/html; charset=utf-8' },
      data: {
        list: objectList
      }
    })
  }
  const deepCopyAndRequest = () => {
    const ObjectList = _.map(eventObjectList, _.clone)
    eventObjectList = []
    requestFn(ObjectList).then(() => {
    })
  }
  eventObjectList.push(sendEventObjectConverter(eventObject))
  if (eventObjectList.length === 10) {
    deepCopyAndRequest()
  }
  setTimeout(() => {
    if (eventObjectList.length > 0) {
      deepCopyAndRequest()
    }
  }, 5000)
}

export const getSktToken = ({ promotionCode = '' }) => {
  let callbackUrl = constant.URL_PROTOCOL_WITH_DOMAIN + '/tcallback.html'
  callbackUrl = promotionCode !== '' ? callbackUrl + '?state=' + encodeURIComponent('promotioncode=' + promotionCode) : callbackUrl
  return apiRequest({
    url: applyQueryString(URL_GET_TID, { callback: callbackUrl, logoutcallback: callbackUrl }),
    method: HTTP_METHOD_GET
  })
}

export const getCategoryList = ({ type = 'vodgenre' }) => {
  return apiRequest({
    url: applyQueryString(URL_CATEGORY_LIST, { type }),
    method: HTTP_METHOD_GET
  })
}

export const getEmergencyInfo = () => {
  const timeStamp = new Date().getTime()
  return axios.get(`${EMERGENCY_JSON_URL}?timestamp=${timeStamp}`)
    .then(({ data }) => {
      const isEmergency = _.get(data, ['emergency', 'use'], 'n') === 'y'
      const emergencyUrl = _.get(data, ['emergency', 'url'], '')
      return { isEmergency, emergencyUrl }
    })
}

export const getAdultCertificationStatus = () => {
  const timeStamp = new Date().getTime()
  return apiRequest({
    url: applyQueryString(URL_GET_ADULT_VERIFICATION_STATUS, { timeStamp }),
    method: HTTP_METHOD_GET
  })
}

// baseball
export const getMonthlyGameResult = ({ yyyymm = '', teamCode = '' }) => {
  const responseFormat = 'json'
  const IF = 'IF-PORG-002'
  const m = 'getTeamCalendarListBand'
  const spoItmCd = 'KBO'
  const ver = '2.0'
  const tgroup = 'B'
  const tvalue = 'BC123'
  const url = applyQueryString(URL_GET_MONTHLY_GAME_RESULT, {
    response_format: responseFormat,
    IF,
    m,
    spo_itm_cd: spoItmCd,
    ver,
    tgroup,
    tvalue,
    date: yyyymm,
    teamcd: teamCode
  })
  return apiRequest({
    url,
    method: HTTP_METHOD_GET
  })
}

export const getGameConditionList = ({ gameId }) => {
  const responseFormat = 'json'
  const IF = 'IF-NSMXPG-113'
  const m = 'getGameConditionList'
  const spoItmCd = 'KBO'
  const ver = '2.0'
  return apiRequest({
    url: applyQueryString(URL_GET_GAME_CONDITION_LIST, {
      response_format: responseFormat,
      IF,
      m,
      spo_itm_cd: spoItmCd,
      ver,
      game_id: gameId
    }),
    method: HTTP_METHOD_GET
  })
}

export const getStadiumConditionList = ({ gameId }) => {
  const responseFormat = 'json'
  const IF = 'IF-NSMXPG-113'
  const m = 'getStadiumConditionList'
  const spoItmCd = 'KBO'
  const ver = '2.0'
  return apiRequest({
    url: applyQueryString(URL_GET_STADIUM_CONDITION_LIST, {
      response_format: responseFormat,
      IF,
      m,
      spo_itm_cd: spoItmCd,
      ver,
      game_id: gameId
    }),
    method: HTTP_METHOD_GET
  })
}
export const getTextRelay = ({ gameId, inning = 1 }) => {
  const responseFormat = 'json'
  const IF = 'IF-NSMXPG-122'
  const m = 'getCacheBaseBallTextRelayList'
  const spoItmCd = 'KBO'
  const ver = '2.0'
  return apiRequest({
    url: applyQueryString(URL_GET_TEXT_RELAY, {
      response_format: responseFormat,
      IF,
      m,
      spo_itm_cd: spoItmCd,
      ver,
      game_id: gameId,
      inning
    }),
    method: HTTP_METHOD_GET
  })
}
export const getTextRelayConvert = ({ gameId, inning = 1 }) => {
  const t = new Date().getTime()
  return apiRequest({
    url: applyQueryString(URL_GET_TEXT_RELAY_CONVERT, {
      gameId,
      inning,
      t
    }),
    method: HTTP_METHOD_GET
  })
}

export const postAdultOtt = ({ pinCode, settings }) => {
  return apiRequest({
    url: URL_POST_ADULT_OTT,
    method: HTTP_METHOD_POST,
    data: {
      pinCode,
      settings
    }
  })
}

export const postAdultConfirm = ({ pinCode, settings = '' }) => {
  const requestBody = {
    pinCode
  }
  if (settings !== '') {
    requestBody.settings = settings
  }
  return apiRequest({
      url: URL_POST_ADULT_CONFIRM,
      method: HTTP_METHOD_POST,
      data: requestBody
    }
  )
}

export const getHighlightPlayerList = ({ offset, limit, date }) => {
  const team = 'ALL'
  const broadcastid = 'FN0_VN357'
  const uiparent = 'GN1'
  const cliptype = 'HL'
  const orderby = 'new'
  return apiRequest({
    url: applyQueryString(URL_GET_HIGHLIGHT_PLAYER_LIST, { team, broadcastid, uiparent, cliptype, offset, limit, orderby, date }),
    method: HTTP_METHOD_GET
  })
}

export const getHighlightContents = ({ contentId }) => {
  return apiRequest({
    url: applyPath(URL_GET_HIGHLIGHT_CONTENTS, contentId),
    method: HTTP_METHOD_GET
  })
}

export const getGameRecord = ({ gameId }) => {
  const responseFormat = 'json'
  const IF = 'IF-NSMXPG-121'
  const m = 'getBaseBallRecordList'
  const spoItmCd = 'KBO'
  const ver = '2.0'
  return apiRequest({
    url: applyQueryString(URL_GET_GAME_RECORD_LIST, {
      response_format: responseFormat,
      IF,
      m,
      spo_itm_cd: spoItmCd,
      ver,
      game_id: gameId
    }),
    method: HTTP_METHOD_GET
  })
}

export const getTeamLatelyGameDate = ({ date }) => {
  return apiRequest({
    url: applyQueryString(URL_GET_TEAM_LATELY_GAME_DATE, { date }),
    method: HTTP_METHOD_GET
  })
}

export const getTeamCalendarListBand = ({ date }) => {
  const responseFormat = 'json'
  const IF = 'IF-PORG-002'
  const m = 'getBaseBallCalendarBand'
  const spoItmCd = 'KBO'
  const ver = '2.0'
  const tgroup = 'B'
  const tvalue = 'BC123'
  const orderby = 'new'
  const contenttype = 'program'
  const genre = 'all'
  const WeekDay = 'all'
  const uitype = 'VN351'
  const uiparent = 'GN9-VN351'
  const uirank = '2'
  const broadcastid = '20508'
  const offset = '0'
  const limit = '20'

  return apiRequest({
    url: applyQueryString(URL_KBO_DAILY_SCHEDULE, {
      response_format: responseFormat,
      IF,
      m,
      spo_itm_cd: spoItmCd,
      ver,
      tgroup,
      tvalue,
      orderby,
      contenttype,
      genre,
      WeekDay,
      uitype,
      uiparent,
      uirank,
      broadcastid,
      offset,
      limit,
      date
    }),
    method: HTTP_METHOD_GET
  })
}

export const getPermissionForContent = (queryObj) => {
  console.log('url: ', applyQueryString(URL_GET_PERMISSION_FOR_CONTENT, queryObj))
  return apiRequest({
    url: applyQueryString(URL_GET_PERMISSION_FOR_CONTENT, queryObj),
    method: HTTP_METHOD_GET
  })
}
export const getProgramNotice = (programid) => {
  return apiRequest({
    url: applyPath(URL_GET_PROGRAM_NOTICE, programid),
    method: HTTP_METHOD_GET
  })
}

export const getUserProfile = (profileid, credential = '') => {
  return apiRequest({
    url: applyQueryString(applyPath(URL_GET_PROFILES_ELYSIUM, profileid), { credential }),
    method: HTTP_METHOD_GET
  })
}

export const knock = () => {
  return apiRequest({
    url: URL_GET_KNOCK,
    method: HTTP_METHOD_GET
  })
}

export const postPromotionUser = ({ promotionId, productType, keyId }) => {
  return apiRequest({
    url: applyPath(URL_PUT_PROMOTION_USER, promotionId),
    method: HTTP_METHOD_POST,
    data: {
      productType,
      keyId
    }
  })
}

export const getSaltedHash = (credential) => {
  const commonParams = getCommonParam()
  commonParams.credential = credential
  return axios.get(`${URL_GET_SALTED_HASH}?${stringify(commonParams)}`,
    {
      responseType: 'json',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json; charset=utf-8'
      }
    })
}
export const getVoucherPurchase = () => {
  return apiRequest({
    url: URL_GET_VOUCHER,
    method: HTTP_METHOD_GET
  })
}

export const getSearchRecommendContents = ({ contenttype, offset = 0, limit = 10, mtype = 'all', keyword = '', version = 2 }) => {
  return apiRequest({
    url: applyQueryString(applyPath(URL_GET_SEARCH_RECOMMEND_CONTENTS, `${contenttype}/list.js`), { offset, limit, mtype, keyword, version }),
    method: HTTP_METHOD_GET
  })
}

export const getSearchPopularContents = ({ contenttype, offset = 0, limit = 10, mtype = 'all' }) => {
  return apiRequest({
    url: applyQueryString(applyPath(URL_GET_SEARCH_POPULAR_CONTENTS, contenttype), { offset, limit, mtype }),
    method: HTTP_METHOD_GET
  })
}
